module.exports = __webpack_public_path__ + "img/120.1.3c2ba846.jpg";